import { Box } from "@mui/material";
import "react-responsive-iframe-viewer/dist/style.css";
import { PageTitle } from "../../commanComponents/PageTitle";
import { String } from "../../constants/Strings";

const WebViewComponent = ({ url, setOpen }) => {
  return (
    <>
      {url && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <PageTitle
            PageTitle={String.AccountAggregator.shareAccount}
            onBack={setOpen ? () => setOpen(false) : undefined}
            sx={{ mx: 0 }}
          />

          <iframe
            src={url}
            title="Dyanamic Iframe"
            allowFullScreen
            style={{
              width: "100%",
              flex: 1,
              border: "none",
            }}
          ></iframe>
        </Box>
      )}
    </>
  );
};

export default WebViewComponent;
